import { IFsFileData, IFsFileType } from "@r3f-component-data-structure"
import { filestore, Filestore } from "../store";
import { FsFile } from ".";

export class FsBaseFile implements IFsFileData {
    fs: Filestore
    id: string
    type: IFsFileType = IFsFileType.Unknown
    baseUrl: string
    size: number = 0
    name: string = ''

    constructor(fileId: string, name: string) {
        this.fs = filestore
        this.id = fileId
        this.name = name
        if (window.location.pathname.endsWith('/')) {
            this.baseUrl = `https://${window.location.host}${window.location.pathname}fs/${fileId}`
        } else {
            this.baseUrl = `https://${window.location.host}${window.location.pathname}/fs/${fileId}`
        }
    }

    load(): Promise<FsFile> {
        throw new Error("Method not implemented.");
    }

    /**
     * Release what the garbage collector cannot: GPU resources and object URLs.
     *
     * Called by `Filestore.merge()`'s caller once an id has left the project AND React has unmounted
     * whatever was rendering it. Plain JS values (blobs, array buffers) need no help — three.js
     * `Texture`s and `URL.createObjectURL` handles do, and leak for the life of the page otherwise.
     *
     * Must be idempotent: a double dispose is a bug in the caller, not a reason to throw.
     */
    dispose(): void {
        // Nothing to release on the base file.
    }
}
